"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
function areArraysEqual(array1, array2) {
    let itemComparer = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (a, b)=>a === b;
    return array1.length === array2.length && array1.every((value, index)=>itemComparer(value, array2[index]));
}
var _default = exports.default = areArraysEqual;
